import React, { useEffect } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { useAuthStore } from '../store/authStore';
import { LoginScreen } from '../screens/LoginScreen';
import { MainTabNavigator } from './MainTabNavigator';
import { PostDetailScreen } from '../screens/PostDetailScreen';
import { ComposeScreen } from '../screens/ComposeScreen';
import { SettingsScreen } from '../screens/SettingsScreen';
import { MutedUsersScreen } from '../screens/MutedUsersScreen';
import { MutedWordsScreen } from '../screens/MutedWordsScreen';
import { BlockedUsersScreen } from '../screens/BlockedUsersScreen';
import { ListsScreen } from '../screens/ListsScreen';
import { ListFeedScreen } from '../screens/ListFeedScreen';
import { AccountSettingsScreen } from '../screens/AccountSettingsScreen';
import { NotificationSettingsScreen } from '../screens/NotificationSettingsScreen';
import { DisplaySettingsScreen } from '../screens/DisplaySettingsScreen';
import { PrivacySettingsScreen } from '../screens/PrivacySettingsScreen';
import { AboutScreen } from '../screens/AboutScreen';
import { ProfileScreen } from '../screens/ProfileScreen';
import { SearchScreen } from '../screens/SearchScreen';
import { NotificationsScreen } from '../screens/NotificationsScreen';
import VideoPlaybackScreen from '../screens/VideoPlaybackScreen';
import { VideoListScreen } from '../screens/VideoListScreen';
import ShortsPlayerScreen from '../screens/ShortsPlayerScreen';
import ChannelDetailScreen from '../screens/ChannelDetailScreen';
import { LoadingIndicator } from '../components/common';
import { RootStackParamList } from '../types/navigation';

const Stack = createNativeStackNavigator<RootStackParamList>();

export const RootNavigator: React.FC = () => {
  const { session, isInitialized, initialize } = useAuthStore();

  useEffect(() => {
    console.log('[RootNavigator] Initializing...');
    // アプリ起動時にセッション復元を試みる
    initialize();
  }, [initialize]);

  console.log('[RootNavigator] isInitialized:', isInitialized, 'session:', !!session);

  // 初期化中はローディング表示
  if (!isInitialized) {
    console.log('[RootNavigator] Showing loading indicator');
    return <LoadingIndicator fullScreen />;
  }

  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        headerStyle: {
          backgroundColor: '#000',
        },
        headerTintColor: '#fff',
        headerTitleStyle: {
          fontWeight: 'bold',
        },
      }}
    >
      {session ? (
        // 認証済み
        <>
          <Stack.Screen name="Main" component={MainTabNavigator} />
          <Stack.Screen
            name="PostDetail"
            component={PostDetailScreen}
            options={{
              headerShown: true,
              headerTitle: '投稿',
              headerBackTitle: '戻る',
            }}
          />
          <Stack.Screen
            name="Compose"
            component={ComposeScreen}
            options={{
              presentation: 'modal',
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Profile"
            component={ProfileScreen}
            options={{
              headerShown: true,
              headerTitle: 'プロフィール',
              headerBackTitle: '戻る',
            }}
          />
          <Stack.Screen
            name="Settings"
            component={SettingsScreen}
            options={{
              headerShown: true,
              headerTitle: '設定',
              headerBackTitle: '戻る',
            }}
          />
          <Stack.Screen
            name="MutedUsers"
            component={MutedUsersScreen}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="MutedWords"
            component={MutedWordsScreen}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="BlockedUsers"
            component={BlockedUsersScreen}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="Lists"
            component={ListsScreen}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="ListFeed"
            component={ListFeedScreen}
            options={{
              headerShown: true,
              headerTitle: 'リスト',
              headerBackTitle: '戻る',
            }}
          />
          <Stack.Screen
            name="AccountSettings"
            component={AccountSettingsScreen}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="NotificationSettings"
            component={NotificationSettingsScreen}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="DisplaySettings"
            component={DisplaySettingsScreen}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="PrivacySettings"
            component={PrivacySettingsScreen}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="About"
            component={AboutScreen}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="VideoPlayback"
            component={VideoPlaybackScreen}
            options={{
              headerShown: true,
              headerTitle: '動画',
              headerBackTitle: '戻る',
            }}
          />
          <Stack.Screen
            name="VideoList"
            component={VideoListScreen}
            options={{
              headerShown: false,
            }}
          />
          <Stack.Screen
            name="ShortsPlayer"
            component={ShortsPlayerScreen}
            options={{
              headerShown: false,
              presentation: 'fullScreenModal',
            }}
          />
          <Stack.Screen
            name="ChannelDetail"
            component={ChannelDetailScreen}
            options={{
              headerShown: true,
              headerTitle: 'チャンネル',
              headerBackTitle: '戻る',
            }}
          />
          <Stack.Screen
            name="Search"
            component={SearchScreen}
            options={{
              headerShown: true,
              headerTitle: '検索',
              headerBackTitle: '戻る',
            }}
          />
          <Stack.Screen
            name="Notifications"
            component={NotificationsScreen}
            options={{
              headerShown: true,
              headerTitle: '通知',
              headerBackTitle: '戻る',
            }}
          />
        </>
      ) : (
        // 未認証
        <Stack.Screen name="Login" component={LoginScreen} />
      )}
    </Stack.Navigator>
  );
};
